export const NAV_SCROLL_MARGIN = 24;

export function getNavHeight() {
  return document.querySelector("nav")?.offsetHeight ?? 64;
}

export function scrollToSectionId(sectionId, behavior = "smooth") {
  const element = document.getElementById(sectionId);
  if (!element) return false;

  const top =
    element.getBoundingClientRect().top +
    window.scrollY -
    getNavHeight() -
    NAV_SCROLL_MARGIN;

  window.scrollTo({ top: Math.max(0, top), behavior });
  return true;
}

export function scrollToSectionWithRetry(
  hash,
  { maxAttempts = 25, interval = 120, behavior = "smooth" } = {}
) {
  // Strip any sub-path suffix (e.g. "#Portofolio/certifications" → "Portofolio")
  const sectionId = hash.replace(/^#/, "").split("/")[0];
  if (!sectionId) return;

  let attempts = 0;

  const tryScroll = () => {
    if (scrollToSectionId(sectionId, behavior)) return;
    attempts += 1;
    if (attempts < maxAttempts) {
      window.setTimeout(tryScroll, interval);
    }
  };

  tryScroll();
}

export function hasLandingHash() {
  return typeof window !== "undefined" && window.location.hash.length > 1;
}

export function goToPortfolio() {
  if (window.location.pathname === "/") {
    scrollToSectionId("Portofolio");
    return;
  }
  window.location.href = "/#Portofolio";
}
